<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label"
    :items.sync="items"
    :total-items="totalItems"
    :multiple-select="multipleSelect"
    component-name="Client"
    :placeholder="placeholder"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as clientsApi from "@/backend/clientsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Клієнт",
    },
    value: {
      type: [Object, Array],
    },
    placeholder: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Array,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    partnershipStopped: {
      type: Boolean,
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    totalItems: 0,
    items: [],
  }),
  computed: {
    flagPartnership() {
      return this.partnershipStopped ? false : "";
    },
  },
  methods: {
    async getItems({ currentPage, perPage, search, partnershipStopped = this.flagPartnership }) {
      const { result, totalItems } = await clientsApi.selectClient(
        currentPage,
        perPage,
        search,
        partnershipStopped,
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>